import { OccConfig } from '@spartacus/core';

export const productsAuxOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        productsPrices: '/users/${userId}/price/search?products=${productsIDs}',
        addToCartInLot: '/orgUsers/${userId}/carts/${cartId}/entries/batch',
        getProducts: '/products/batch-details',
      } as any,
    },
  },
};
